import merge from "deepmerge";
import buildData from "../buildData";
import configureTooltip from "../tooltip/main";
import chartUtils from "../../../utils/chart-utils";

var buildPieConfiguration = function buildPieConfiguration(seriesConfig, seriesDataObj, customConfig) {
  var PieHemisphere = seriesConfig.PieHemisphere,
      ColorPalette = seriesConfig.ColorPalette,
      SeriesType = seriesConfig.SeriesType;
  var LabelField = seriesConfig.LabelField,
      ValueField = seriesConfig.ValueField,
      ShowCategoryLabels = seriesConfig.ShowCategoryLabels,
      ShowLabels = seriesConfig.ShowLabels,
      ShowPercentage = seriesConfig.ShowPercentage,
      ShowLegend = seriesConfig.ShowLegend,
      CrumbFieldName = seriesConfig.CrumbFieldName,
      CrumbDisplayFieldName = seriesConfig.CrumbDisplayFieldName;
  var ValueFormat = seriesConfig.ValueFormat,
      CurrencySymbol = seriesConfig.CurrencySymbol,
      BaseFormat = seriesConfig.BaseFormat;


  var startAngle = void 0,
      endAngle = void 0;
  if (PieHemisphere == "Top") {
    startAngle = -90;
    endAngle = 90;
  } else if (PieHemisphere == "Bottom") {
    startAngle = 90;
    endAngle = 270;
  }

  var seriesArray = seriesDataObj.Pie;
  var total = seriesArray.reduce(function (acc, dataPoint) {
    return acc += dataPoint[ValueField];
  }, 0);

  return merge({
    size: "90%",
    startAngle: startAngle,
    endAngle: endAngle,
    colors: ColorPalette ? ColorPalette : undefined,
    innerSize: SeriesType.toLowerCase() === "doughnut" ? "60%" : "0%",
    type: "pie",
    dataLabels: {
      enabled: true,
      distance: ShowLabels && !ShowCategoryLabels && !ShowPercentage ? -25 : 25,
      style: {
        fontSize: "12px",
        textOutline: "none"
      },
      formatter: function formatter() {
        var valueLabel = chartUtils.format(this.y, ValueFormat, CurrencySymbol, null, BaseFormat);
        var categoryLabel = this.point.options.name;
        var percentLabel = (this.y / total * 100).toFixed(1) + "%";

        var label = "";

        if (ShowCategoryLabels) label += categoryLabel;
        if (ShowCategoryLabels && (ShowLabels || ShowPercentage)) label += ": ";
        if (ShowLabels) label += valueLabel;
        if (ShowLabels && ShowPercentage) label += ": ";
        if (ShowPercentage) label += percentLabel;
        if (label === "") label = undefined;

        return Math.abs(this.y / total) > 0.05 ? label : undefined;
      }
    },
    showInLegend: ShowLegend,
    data: buildData(seriesArray, LabelField, ValueField, CrumbFieldName, CrumbDisplayFieldName, null, null, seriesConfig),
    tooltip: configureTooltip(SeriesType, seriesConfig)
  }, customConfig);
};

export default buildPieConfiguration;